import React from 'react'
import './Writecard.css'

function WriteCard(props) {
    return (
      <>
      <div className='container'>
        <div className='card'>
            <img className='pic' src={props.img}></img>
            <div className='titlebox'>
                <h1 className='titlecard'>{props.title}</h1>
                <p className='publication'>Publication: {props.publication}</p>
                <a href={props.link} target="_blank" className="button">Read Here</a>
            </div>
        </div>
      </div>
  
      
      </>
    )
  }
  
  export default WriteCard